"use client";

import {
  createContext,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";

export const PageTransitionContext = createContext<
  [
    isTransitioning: boolean,
    setIsTransitioning: Dispatch<SetStateAction<boolean>>,
  ]
>([
  false,
  () => {
    // do nothing
  },
]);

export default function PageTransitionProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isTransitioning, setIsTransitioning] = useState(false);

  return (
    <PageTransitionContext.Provider
      value={[isTransitioning, setIsTransitioning]}
    >
      {children}
    </PageTransitionContext.Provider>
  );
}
